const API_BASE = '/api/edugen-family';

async function api(path, { method = 'GET', body, isFormData = false } = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers: isFormData ? undefined : { 'Content-Type': 'application/json' },
    body: isFormData ? body : (body ? JSON.stringify(body) : undefined),
    credentials: 'include',
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

const toFormData = (fields = {}) => {
  const formData = new FormData();
  Object.entries(fields).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    formData.append(key, value);
  });
  return formData;
};

export const EdugenFamilyService = {
  // Public feed (published only) — used by the Home page section
  listPublic: (type) => api(`?type=${encodeURIComponent(type)}`),

  // Admin — full list including drafts
  listAdmin: (type) => api(`/admin${type ? `?type=${encodeURIComponent(type)}` : ''}`),
  getMember: (id) => api(`/${id}`),

  create: (fields) => api('', { method: 'POST', body: toFormData(fields), isFormData: true }),
  update: (id, fields) => api(`/${id}`, { method: 'PUT', body: toFormData(fields), isFormData: true }),
  remove: (id) => api(`/${id}`, { method: 'DELETE' }),
};

export default EdugenFamilyService;
